import { useGetRequest, RequestResponse, RequestPromise, PutRequest } from "../../hook/useRequest";
import { getToken } from "../../utils/storage/Token";
import { AppSettings } from "../../AppSettings";
import {
    BillingChangeDeclarationURSSAFPostInterface,
    DeclarationURSSAFChangeStateInterface,
} from "./Interfaces/DeclarationInterface";

const API_URL_DECLARATION = AppSettings.API_FREELANCERIE + "/declaration";

const useFetchDeclarationUrssaf = (idUser: number, year: number, forceUpdated = 0): RequestResponse => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest(
        `${AppSettings.API_FREELANCERIE}/declaration/resume_urssaf/${idUser}&${year}`,
        forceUpdated,
        config,
    );
};

const useFetchDeclarationResume = (idUser: number, year: number, forceUpdated = 0): RequestResponse => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest(`${AppSettings.API_FREELANCERIE}/declaration/resume/${idUser}&${year}`, forceUpdated, config);
};

const useFetchEcheanceUrssaf = (idUser: number, year: number, forceUpdated = 0): RequestResponse => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest(
        `${AppSettings.API_FREELANCERIE}/declaration/echeance_urssaf/${idUser}&${year}`,
        forceUpdated,
        config,
    );
};

export interface DeclarationPendingAlerts {
    tva: { month: number; year: number } | null;
    urssaf: { num: number; year: number; dateEcheance: string; desc: string } | null;
}

const useFetchPendingAlerts = (idUser: number, forceUpdated = 0): RequestResponse<DeclarationPendingAlerts> => {
    const config = { headers: { Authorization: getToken() } };
    return useGetRequest<DeclarationPendingAlerts>(
        `${AppSettings.API_FREELANCERIE}/declaration/pending_alerts/${idUser}`,
        forceUpdated,
        config,
    );
};

const UpdateChangeStatusDeclarationURSSAF = (
    id_user: number,
    declaration: DeclarationURSSAFChangeStateInterface,
): RequestPromise => {
    const config = { headers: { Authorization: getToken() } };
    return PutRequest(`${API_URL_DECLARATION}/state_urssaf/${id_user.toString()}`, declaration, config);
};

const UpdateDeclaration = (
    id_user: number,
    declaration: BillingChangeDeclarationURSSAFPostInterface,
): RequestPromise => {
    const config = { headers: { Authorization: getToken() } };
    return PutRequest(`${API_URL_DECLARATION}/urssaf/${id_user.toString()}`, declaration, config);
};

const UpdateChangeStatusDeclarationTVA = (
    id_user: number,
    declaration: { month: number; year: number; state: number },
): RequestPromise => {
    const config = { headers: { Authorization: getToken() } };
    return PutRequest(`${API_URL_DECLARATION}/state_tva/${id_user.toString()}`, declaration, config);
};

export {
    useFetchDeclarationUrssaf,
    UpdateDeclaration,
    useFetchDeclarationResume,
    useFetchEcheanceUrssaf,
    useFetchPendingAlerts,
    UpdateChangeStatusDeclarationURSSAF,
    UpdateChangeStatusDeclarationTVA,
};
